<script lang="ts">

import { defineComponent, computed, onMounted } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { v4 as uuid } from 'uuid'
import { dialogService } from '@siteminder/sui-core/services'
import { useRoute, router } from '../../router'
import { useI18n } from '../../setup/setup-i18n'
import { LOCAL_STORAGE_REDIRECT_URI_KEY } from '../../constants'

const { useActions: useParterStoreActions, useGetters: usePartnerStoreGetters } = createNamespacedHelpers('Partner')

export default defineComponent({
  name: 'PartnerSSOPage',

  setup() {

    const { t } = useI18n()

    const currentRoute = useRoute()

    const { authenticate } = useParterStoreActions(['authenticate'])
    const { partnerUserIdentity } = usePartnerStoreGetters(['partnerUserIdentity'])

    onMounted(async () => {
      await handleAuthenticate()
    })

    const token = computed(() => currentRoute.value?.params.token)

    const partnerCode = computed(() => currentRoute.value?.params.partnerCode)

    const handleNetworkError = () => {

      const title = t('PartnerSSOPage.networkErrorTitle')
      const description = t('PartnerSSOPage.networkErrorDescription')

      dialogService({
        title,
        bodyContent: description,
        confirmButtonText: t('PartnerSSOPage.networkErrorReloadButton'),
        type: 'warning',
        beforeConfirm: async (confirm) => {

          await handleAuthenticate()

          return confirm()
        },
        beforeClose: async (close) => {

          router.replace({ name: 'UnknownErrorPage' })

          return close()
        },
      })

    }

    const handleAuthenticate = async () => {

      try {

        localStorage.removeItem(LOCAL_STORAGE_REDIRECT_URI_KEY)

        await authenticate({
          token: token.value,
          partnerCode: partnerCode.value,
        })

        router.push({
          name: 'AuthenticatePage',
          query: {
            code: partnerUserIdentity.value?.token,
            tenantCode: partnerUserIdentity.value?.tenantCode,
            state: uuid(),
          },
        })

      } catch (error) {
        if (error.request && !error.response) {
          handleNetworkError()
        } else {
          router.replace({ name: 'UnknownErrorPage' })
        }
      }

    }

  },
})

</script>

<template>
  <div class="authenticate">
    <sm-loader />
  </div>
</template>

<style lang="scss" scoped>
.authenticate {
  @apply flex justify-center items-center min-h-screen;
}
</style>
